/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FaceMask(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,72h-1.03125a16.03948,16.03948,0,0,0-9.501-9.43311l-80-29.0913a16.02485,16.02485,0,0,0-10.93554,0l-80,29.09082A16.04022,16.04022,0,0,0,33.03125,72H32A32.03635,32.03635,0,0,0,0,104v24a32.03635,32.03635,0,0,0,32,32h5.19678c6.561,14.38086,19.25537,26.99854,37.63183,37.20752,21.02246,11.67871,43.52491,16.96045,49.91944,18.30029a15.72388,15.72388,0,0,0,6.50293,0c6.3955-1.33984,28.898-6.62158,49.92041-18.30029,18.37646-10.209,31.0708-22.82666,37.63183-37.20752H224a32.03635,32.03635,0,0,0,32-32V104A32.03635,32.03635,0,0,0,224,72ZM32,144a16.01833,16.01833,0,0,1-16-16V104A16.01833,16.01833,0,0,1,32,88v48a58.66962,58.66962,0,0,0,.55273,8Zm136,8H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm72,8a16.01833,16.01833,0,0,1-16,16h-.55273A58.66962,58.66962,0,0,0,224,136V88a16.01833,16.01833,0,0,1,16,16Z" />
    </Svg>
  );
}

export default FaceMask;
